import React from "react";
import './Join.css'; // Create a CSS file for styling

const Join = () => {
  return (
    <div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <h1>Join</h1>
        <div id="flexContainer">
            <div className='box3'>
                  <h2>Become a part of the journey</h2>
                  <br></br>
                  <br></br>
                  <p>Do you like consulting, data and pharma?</p>
                  <br></br>
                  <p>Then get in touch and let's have a chat</p>
                  <br></br>
                  <p>Call at +45 20 89 40 86</p>
                  <br></br>                  
                  <p></p>
            </div>
        </div>
    </div>

  );
};

export default Join;
